module.exports = __webpack_public_path__ + "img/link-externo4.c61374c3.svg";